class SkImageCompare extends HTMLElement {
  #range;
  #mediaQuery;
  #abortController = new AbortController();

  connectedCallback() {
    this.#range = this.querySelector('[data-compare-range]');
    if (!(this.#range instanceof HTMLInputElement)) return;

    this.#mediaQuery = window.matchMedia('(max-width: 749px)');
    const { signal } = this.#abortController;

    this.#range.addEventListener('input', this.#updateFromRange, { signal });
    this.#range.addEventListener('change', this.#updateFromRange, { signal });
    this.#mediaQuery.addEventListener('change', this.#applyResponsivePosition, { signal });
    this.addEventListener('dblclick', this.#resetPosition, { signal });

    this.#applyResponsivePosition();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #applyResponsivePosition = () => {
    const position = this.#mediaQuery?.matches
      ? Number(this.dataset.mobilePosition)
      : Number(this.dataset.desktopPosition);

    this.#setPosition(Number.isFinite(position) ? position : 50);
  };

  #updateFromRange = () => {
    this.#setPosition(Number(this.#range.value));
  };

  #resetPosition = (event) => {
    if (event.target instanceof HTMLAnchorElement) return;
    this.#applyResponsivePosition();
  };

  #setPosition(position) {
    if (!(this.#range instanceof HTMLInputElement)) return;

    const boundedPosition = Math.min(100, Math.max(0, position));
    this.#range.value = String(boundedPosition);
    this.style.setProperty('--sk-compare-position', `${boundedPosition}%`);
    this.classList.toggle('is-fully-left', boundedPosition <= 0);
    this.classList.toggle('is-fully-right', boundedPosition >= 100);
    this.#range.setAttribute('aria-valuenow', String(Math.round(boundedPosition)));
    this.#range.setAttribute('aria-valuetext', `${Math.round(boundedPosition)}% left image and ${Math.round(100 - boundedPosition)}% right image`);
  }
}

if (!customElements.get('sk-image-compare')) {
  customElements.define('sk-image-compare', SkImageCompare);
}
